const styles = (theme) => ({
  cell: {
    padding: 0,
    color: theme.color.grey_8A,
    border: 'none',
    fontSize: 14,

    '&:nth-child(1)': {
      width: 64,
    },
  },
  black: {
    color: theme.color.black_80,
  },
  alignValuesToRight: {
    textAlign: 'end',
  },
  alignValuesToLeft: {
    textAlign: 'start',
  },
  paddingBetweenRecords: {
    '&:not(:last-child) td': {
      paddingBottom: theme.spacing(1.25),
    },
  },
});

export default styles;
